// extracted by mini-css-extract-plugin
export var accordionIcon = "MegaMenu-module--accordionIcon--f44cf";
export var accordionIconOpen = "MegaMenu-module--accordionIconOpen--11b12";
export var accordionListClosed = "MegaMenu-module--accordionListClosed--76a01";
export var accountButton = "MegaMenu-module--accountButton--c93be";
export var accountButtonContainer = "MegaMenu-module--accountButtonContainer--6dfb5";
export var accountTabListItem = "MegaMenu-module--accountTabListItem--6421d";
export var bca = "MegaMenu-module--bca--4ae4c";
export var bcaInactive = "MegaMenu-module--bcaInactive--d6a9b";
export var bcaTheme = "MegaMenu-module--bcaTheme--2c419";
export var container = "MegaMenu-module--container--f095a";
export var footerLinks = "MegaMenu-module--footerLinks--bc127";
export var footerLinksContainer = "MegaMenu-module--footerLinksContainer--1501b";
export var footerLinksPrimary = "MegaMenu-module--footerLinksPrimary--fab06";
export var footerLinksSecondary = "MegaMenu-module--footerLinksSecondary--1300b";
export var intro = "MegaMenu-module--intro--55aba";
export var introHeading = "MegaMenu-module--introHeading--9bc04";
export var introText = "MegaMenu-module--introText--0748e";
export var lgBreak = "1200";
export var linkBase = "MegaMenu-module--linkBase--4c32e";
export var linkRegion1 = "MegaMenu-module--linkRegion1--86af9";
export var linkRegion2 = "MegaMenu-module--linkRegion2--4f9ce";
export var linkRegion3 = "MegaMenu-module--linkRegion3--c08c2";
export var linkRegion4 = "MegaMenu-module--linkRegion4--9b9ce";
export var linkRegion5 = "MegaMenu-module--linkRegion5--f2a78";
export var list = "MegaMenu-module--list--a6045";
export var loginSection = "MegaMenu-module--loginSection--289d8";
export var loginSectionLink = "MegaMenu-module--loginSectionLink--2df45";
export var mdBreak = "992";
export var navMegaMenuBase = "MegaMenu-module--navMegaMenuBase--238bf";
export var onlineBankLinkItem = "MegaMenu-module--onlineBankLinkItem--3b371";
export var pca = "MegaMenu-module--pca--29dec";
export var pcaInactive = "MegaMenu-module--pcaInactive--eb196";
export var productLinks = "MegaMenu-module--productLinks--5a3b9";
export var productList = "MegaMenu-module--productList--b0794";
export var productListLink = "MegaMenu-module--productListLink--71d61";
export var secondaryItemContainer = "MegaMenu-module--secondaryItemContainer--95906";
export var sectionHeading = "MegaMenu-module--sectionHeading--632a4";
export var smBreak = "768";
export var textLink = "MegaMenu-module--textLink--78cb0";
export var xsBreak = "480";